/****************************************************
 * Module Name:  reassignCustomer.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { useMemo, useState } from "react";
import { DataGridPro, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarExport, GridToolbarFilterButton, GridToolbarQuickFilter } from "@mui/x-data-grid-pro";
import { Box, Button, Container, Checkbox, FormControlLabel, FormGroup, IconButton, TextField, Tooltip, Typography, } from "@mui/material";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import ClearIcon from '@mui/icons-material/Clear';
import CircularProgress from "@mui/material/CircularProgress";
import Utility from "../../utility/utility";
import { useEffect } from "react";
import Constants from "../../utility/constants";
import Select from "react-select";
import renderCellExpand from "../common/dataGridCellExpand";
import NoPermission from "../common/noPermission";
import UserProxy from "../../utility/proxy/manager/userProxy";
import EmployeeProxy from "../../utility/proxy/manager/employeeProxy";
import SelectUserModal from "../operations/selectUserModal";
import TransferWithinAStationIcon from '@mui/icons-material/TransferWithinAStation';
import { Modal } from "react-bootstrap";
import logo from '../../images/pansuriya.jpg'
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import CommonSnackbar from "../common/commonSnackBar";
import StoneProxy from "../../utility/proxy/manager/stoneProxy";
import LabProxy from "../../utility/proxy/manager/labProxy";
import LocationProxy from "../../utility/proxy/manager/locationProxy";
import CutProxy from "../../utility/proxy/manager/cutProxy";
import PolProxy from "../../utility/proxy/manager/polProxy";
import SymProxy from "../../utility/proxy/manager/symProxy";
import FloProxy from "../../utility/proxy/manager/floProxy";
import ClarityProxy from "../../utility/proxy/manager/clarityProxy";
import ColorProxy from "../../utility/proxy/manager/colorProxy";
import SizeProxy from "../../utility/proxy/manager/sizeProxy";
import ShapeProxy from "../../utility/proxy/manager/shapeProxy";
import FileCopyRoundedIcon from "@mui/icons-material/FileCopyRounded";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import MarketSellWolzaModal from "../common/marketSellWolzaModal";
import QueueIcon from '@mui/icons-material/Queue';
import SystemSalesModal from "./systemSalesModal";
import StoneTypeProxy from "../../utility/proxy/manager/stoneTypeProxy";
import PageTitle from "../common/pageTitle";
import UserDetailModal from "../operations/userDetailModal";

const ReassignCustomer = () => {
    const [listData, setListData] = useState([]);
    const [selectionModel, setSelectionModel] = useState([]);
    const [loadingButton, setLoadingButton] = useState(false);
    const [listLoader, setListLoader] = useState(false);
    const [employeeData, setEmployeeData] = useState({
        employee: [],
        employeeOptions: [],
    });
    const [filteredEmployeeData, setFilteredEmployeeData] = useState({
        employee: [],
        employeeOptions: [],
    });

    const [showSelectUserModal, setShowSelectUserModal] = useState(false);
    const [showMultiCustomerSelectionModal, setShowMultiCustomerSelectionModal] = useState(false);
    const [data, setData] = useState("");

    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [snackBarTitle, setSnackBarTitle] = useState("");
    const [snackBarMessage, setSnackBarMessage] = useState("");
    const [snackBarVariant, setSnackBarVariant] = useState("");
    const [showSnackbar, setShowSnackbar] = useState(false);

    const [wolzaCriteria, setWolzaCriteria] = useState(Utility.getDefaultCriteriaToGenerateLink);

    const [labOptions, setLabOptions] = useState([]);
    const [locationOptions, setLocationOptions] = useState([]);
    const [cutOptions, setCutOptions] = useState([]);
    const [polOptions, setPolOptions] = useState([]);
    const [symOption, setSymOptions] = useState([]);
    const [floOption, setFloOptions] = useState([]);
    const [clarityOptions, setClarityOptions] = useState([]);
    const [colorOptions, setColorOptions] = useState([]);
    const [sizeOptions, setSizeOptions] = useState([]);
    const [shapeOptions, setShapeOptions] = useState([]);
    const [stoneTypeOptions, setStoneTypeOptions] = useState([]);
    const [showInvoiceModal, setShowInvoiceModal] = useState(false);
    const [showWolzaDetailModal, setShowWolzaDetailModal] = useState(false);
    const [stoneType, setStoneType] = useState("");
    const [customerData, setCustomerData] = useState({
        customer: [],
        customerOptions: [],
    });
    const [filterValues, setFilterValues] = useState({});
    const [unassignedCustomerCheck, setUnassignedCustomerCheck] = useState(false);
    const [listDataMap, setListDataMap] = useState([]);
    const [userIds, setUserIds] = useState([]);
    const [showUserDetailModal, setShowUserDetailModal] = useState(false);
    const defaultStatus = [
        { value: "UNPAID", label: "UNPAID" },
        { value: "PAID", label: "PAID" }
    ];

    useEffect(() => {
        PageTitle("MASTER_REASSIGNCUSTOMER");
        LabProxy.GetAllLabMini((response) => {
            let lLabOption = [];
            response.map((data) => lLabOption.push({ value: data.name, label: data.name, selected: false }))
            setLabOptions(lLabOption);
        });

        LocationProxy.GetAllLocationDetailMini((response) => {
            let lLocationOption = [];
            response.map((data) => lLocationOption.push({ value: data.id, label: data.name, selected: false }));
            setLocationOptions(lLocationOption);
        });

        CutProxy.GetAllCutMini((response) => {
            let lCutOption = [];
            response.map((data) => lCutOption.push({ value: data.name, label: data.name, selected: false }));
            setCutOptions(lCutOption);
        });

        PolProxy.GetAllPolMini((response) => {
            let lPolOption = [];
            response.map((data) => lPolOption.push({ value: data.name, label: data.name, selected: false }));
            setPolOptions(lPolOption);
        });

        SymProxy.GetAllSymMini((response) => {
            let lSymOption = [];
            response.map((data) => lSymOption.push({ value: data.name, label: data.name, selected: false }));
            setSymOptions(lSymOption);
        });

        FloProxy.GetAllFloMini((response) => {
            let lFloOption = [];
            response.map((data) => lFloOption.push({ value: data.name, label: data.name, selected: false }));
            setFloOptions(lFloOption);
        });

        ClarityProxy.GetAllClarityMini((response) => {
            let lClarityOption = [];
            response.map((data) => lClarityOption.push({ value: data.name, label: data.name, selected: false }));
            setClarityOptions(lClarityOption);
        });

        ColorProxy.GetAllColorMini((response) => {
            let lColorOption = [];
            response.map((data) => lColorOption.push({ value: data.name, label: data.name, selected: false }));
            setColorOptions(lColorOption);
        });

        SizeProxy.GetAllSizeMini((response) => {
            let lWeightOption = [];
            response.map((iWeight) => lWeightOption.push({ value: iWeight.id, label: iWeight.name, selected: false }));
            setSizeOptions(lWeightOption);
        });

        ShapeProxy.GetAllShapeMini((response) => {
            let res = response.filter((iShape) => iShape.disabled === false);

            let lShapeOption = [];
            res.map((iShape) => lShapeOption.push({ value: iShape.id, label: iShape.name, selected: false, image: iShape.image }));

            setShapeOptions(lShapeOption);
        });
        StoneTypeProxy.GetAllStoneTypeByDisabled(false, response => {
            if (response) {
                let stoneTypeOption = [];
                response.map(stonetype => {
                    if (stonetype.name !== 'N')
                        stoneTypeOption.push({ value: stonetype.name, label: stonetype.fullname, selected: true })

                    return true;
                });
                setStoneTypeOptions(stoneTypeOption);
            }
        })
    }, []);

    useEffect(() => {
        let searchCriteria = wolzaCriteria;
        searchCriteria.labOption = labOptions;
        searchCriteria.locationOption = locationOptions;
        searchCriteria.cutOption = cutOptions;
        searchCriteria.polOption = polOptions;
        searchCriteria.symOption = symOption;
        searchCriteria.floOption = floOption;
        searchCriteria.shapeOption = shapeOptions;
        searchCriteria.colorOption = colorOptions;
        searchCriteria.clarityOption = clarityOptions;
        searchCriteria.weightOption = sizeOptions;
        searchCriteria.stonetypeOption = stoneTypeOptions;
        setWolzaCriteria(searchCriteria);
    }, [labOptions, locationOptions, cutOptions, polOptions, symOption, floOption, sizeOptions, shapeOptions, colorOptions, clarityOptions, stoneTypeOptions])

    // eslint-disable-next-line
    const [local_Permission, setLocal_Permission] = useState(
        Constants.USER_PERMISSION.filter(
            (iPermission) =>
                iPermission.permissionid ===
                Constants.PERMISSIONS.MASTER_REASSIGNCUSTOMER
        )
    );

    const allowed = Utility.isReadAllowed(local_Permission);

    const NATURAL = "N";

    const LAB_GROWN = "LG";

    useEffect(() => {
        if (allowed)
            getAllEmployeeData();
    }, []);

    const getAllEmployeeData = () => {
        UserProxy.GetAllEmployeeMini("", (response) => {  // need to fetch sales team employees but currently customers are attached to diffrent dept employees too
            if (response)
                prepareUserData(response);
        });
    };

    const prepareUserData = (response) => {

        let optionsArray = [];
        optionsArray.push({ value: "*", label: "ALL EMPLOYEES", })
        response.map((data) => {
            let option = {
                value: data.id,
                label: data.username,
            };
            optionsArray.push(option);
            return true;
        });
        setUserIds(optionsArray.filter(option => option.value !== "*").map(option => option.value));
        setEmployeeData({
            employeeOptions: optionsArray,
            employee: [],
        });

        return true;
    };

    const openLinkInNewTab = (link) => {
        window.open(link, '_blank', 'noopener,noreferrer');
    };

    const handleSubmit = () => {

        let values = [];
        data.replaceAll('\n', ',').replaceAll(' ', ',').split(',').forEach((e) => {
            if (e && e !== '') {
                values.push(e)
            }
        });

        let value = Utility.StringToIntegerArray(values)
        let newValue = new Set(selectionModel);

        let dataIds = [];
        listData.map(ilistData => {
            dataIds.push(ilistData.id);
            return true;
        });

        value.map(ivalue => {
            if (dataIds.includes(ivalue)) {
                newValue.add(ivalue);
            }
            return true;
        })

        let matchedList = [];
        let unmatchedList = [];
        listData.map(ilistData => {
            if (newValue.has(ilistData.id)) {
                matchedList.push(ilistData);
            } else {
                unmatchedList.push(ilistData);
            }
            return true;
        })

        setData("");
        setListData(matchedList.concat(unmatchedList));
        setSelectionModel(Array.from(newValue));
        setShowMultiCustomerSelectionModal(false);
    }

    const handleClose = () => {
        setShowSelectUserModal(false);
        setShowSnackbar(false);
        setShowMultiCustomerSelectionModal(false);
    };

    const fullOptionToValue = (selectedData, mainData) => {
        let newArr = [];
        selectedData.map((data) => {
            if (data.value === "*") {
                return (mainData.map((option) => {
                    if (option.value !== "*") {
                        newArr.push(option.value);
                        return true;
                    }
                    return true;
                }));
            }
            return true;
        })
        return Utility.GetValueArrayWithStarReplace(selectedData, newArr);
    };

    const handleSearch = () => {

        let employeeids;
        if (unassignedCustomerCheck)
            employeeids = -1;
        else if (employeeData.employee.length > 0) {
            employeeids = fullOptionToValue(employeeData.employee, employeeData.employeeOptions);
        } else
            return;

        let data = {
            from: (fromDate !== null && fromDate !== "") ?
                dayjs(fromDate).format('YYYY-MM-DD') + "T00:00:00.000Z" : null,
            to: (toDate !== null && toDate !== "") ?
                dayjs(toDate).format('YYYY-MM-DD') + "T23:59:59.999Z" : null,
        }

        setListLoader(true);
        if (!unassignedCustomerCheck) {
            data = { ...data, employeeids: employeeids, }
            EmployeeProxy.GetCustomerPotentialSellDetails(
                data,
                (responseData) => {
                    processListData(responseData);
                    processMapData(responseData);
                });
        } else {
            EmployeeProxy.GetUnassignedCustomerPotentialSellDetails(
                employeeids, data,
                (responseData) => {
                    processListData(responseData);
                });
        }
    };

    const processMapData = (responseData) => {
        let dataMap = new Map();
        if (responseData)
            responseData.forEach(iData => dataMap.set(iData.id, iData));
        setListDataMap(dataMap)
    }

    const processListData = (responseData) => {
        if (responseData) {
            const uniqueFilterValues = {
                companyname: Utility.getDistinctOptions(responseData, "companyname"),
                username: Utility.getDistinctOptions(responseData, "username"),
                first_name: Utility.getDistinctOptions(responseData, "first_name"),
                employeename: Utility.getDistinctOptions(responseData, "employeename"),
                location: Utility.getDistinctOptions(responseData, "location"),
                locationcountry: Utility.getDistinctOptions(responseData, "country"),
                customercountry: Utility.getDistinctOptions(responseData, "customercountry"),
                customerstate: Utility.getDistinctOptions(responseData, "customerstate"),
                customercity: Utility.getDistinctOptions(responseData, "customercity"),
            };

            setFilterValues(uniqueFilterValues);
            let newListData = [];
            responseData.forEach((res) => {
                let listOp = {
                    ...res,
                    naturallink: "",
                    labgrownlink: "",
                }
                newListData.push(listOp);
                return true;
            })

            setListData(newListData);
        }
        setListLoader(false);
    }

    const filterEmployeeData = () => {

        if (employeeData.employeeOptions.length > 1) {
            let filteredEmployees = employeeData.employeeOptions.filter(emp =>
                emp.value !== '*' &&
                !employeeData.employee.some(selectedEmp => emp.value === selectedEmp.value)
            );

            setFilteredEmployeeData({
                employee: [filteredEmployees[0]],
                employeeOptions: filteredEmployees,
            });
        }
    }

    const saveReassign = (toEmployeeid) => {
        setLoadingButton(true);
        let data = [];

        let custEmpMap = new Map();

        if (!unassignedCustomerCheck) {
            selectionModel.forEach(iData => {
                let customer = listDataMap.get(iData);
                if (custEmpMap.get(customer.employeeid)) {
                    let custids = custEmpMap.get(customer.employeeid);
                    custEmpMap.set(customer.employeeid, [...custids, iData])

                } else {
                    custEmpMap.set(customer.employeeid, [iData])
                }
            })
            custEmpMap.forEach((value, key) => {

                data.push({
                    fromemployeeid: key,
                    toemployeeid: toEmployeeid,
                    customerids: value
                });
            })
        } else {
            selectionModel.forEach(iData => {
                data.push({
                    fromemployeeid: null,
                    toemployeeid: toEmployeeid,
                    customerids: [iData]
                });
            });
        }

        EmployeeProxy.ReassignCustomer(data, (responseData) => {
            if (responseData) {
                handleSearch();
                setLoadingButton(false);
                setShowSnackbar(true);
                setSnackBarMessage("Customers Reassigned Successfully");
                setSnackBarVariant("success");
                setSnackBarTitle("Success")

            } else {
                setShowSnackbar(true)
                setSnackBarMessage(Constants.APiFailErrorMessage)
                setSnackBarVariant("error")
                setSnackBarTitle("Failed")
                setLoadingButton(false);
            }
            setShowSelectUserModal(false);
        });
    }

    useEffect(() => {
        if (unassignedCustomerCheck)
            handleSearch();
    }, [unassignedCustomerCheck]);

    const generateLink = async (customerdata, stoneType) => {
        return new Promise((resolve, reject) => {
            let data = wolzaCriteria;

            data.stonetypeOption = stoneType === "N" ? [] : stoneTypeOptions;
            data.selectedCustomer = {
                "label": customerdata.companyname + " | " + customerdata.username,
                "value": customerdata.id,
            };

            let reqData = {
                from: (fromDate !== null && fromDate !== "") ?
                    Utility.ConvertLocalTimeToUtc(fromDate).slice(0, 11) + "00:00:00.000Z" : null,
                to: (toDate !== null && toDate !== "") ?
                    Utility.ConvertLocalTimeToUtc(toDate).slice(0, 11) + "23:59:59.999Z" : null,

                createdby: Constants.loggedInUser.id,
                customerid: customerdata.id,
                consigneeid: -1,
                criteria: JSON.stringify(JSON.stringify(data)),
                stonetype: stoneType,
            }

            StoneProxy.GenerateCriteriaLinkForWolzaDataStoneIds(Constants.loggedInUser.id, reqData, (response) => {
                if (response) {
                    let link = `${window.location.origin}/app/operation/stock?id=${response.guid}`;
                    let newListData = [];
                    listData.forEach((res) => {

                        if (customerdata.id === res.id) {
                            let listOp;
                            if (stoneType === "N") {
                                listOp = {
                                    ...res,
                                    naturallink: link,
                                }
                            } else {
                                listOp = {
                                    ...res,
                                    labgrownlink: link,
                                }
                            }
                            newListData.push(listOp);
                        } else {
                            newListData.push(res);
                        }
                    });
                    setListData(newListData);
                    setShowSnackbar(true);
                    setSnackBarMessage("Link generated successfully");
                    setSnackBarVariant("success");
                    resolve(link);  // Resolve the Promise with the generated link
                } else {
                    setShowSnackbar(true);
                    setSnackBarMessage(Constants.APiFailErrorMessage);
                    setSnackBarVariant("error");
                    reject("Failed to generate link");  // Reject the Promise in case of failure
                }
            });
        });
    }

    const handleActualInvoiceDetail = (params) => {
        handleCustomerData(params);
        setShowInvoiceModal(true);
    }

    const handleWolzaDetail = (params, stoneType) => {
        handleCustomerData(params);
        setStoneType(stoneType);
        setShowWolzaDetailModal(true);
    }

    const handleCustomerData = (params) => {
        let optionsArray = [];
        optionsArray.push({ value: params.row.id, label: params.row.companyname })

        let customerData = {
            customerOptions: optionsArray,
            customer: optionsArray,
        }
        setCustomerData(customerData);
    }

    const columns = useMemo(() =>
        [
            {
                field: "id",
                headerName: "USER ID",
                headerAlign: "center",
                align: "center",
                type: "number",
                valueFormatter: (params) => params.value,
                minWidth: 50,
                renderCell: renderCellExpand,
            },
            {
                field: "companyname",
                headerName: "COMPANY NAME",
                headerAlign: "center",
                align: "center",
                minWidth: 150,
                flex: 1,
                type: "singleSelect",
                valueOptions: filterValues ? filterValues.companyname : [],
                filterOperators: Utility.combinedFilters(),
                renderCell: renderCellExpand,
            },
            {
                field: "username",
                headerName: "USER",
                headerAlign: "center",
                align: "center",
                minWidth: 130,
                flex: 1,
                type: "singleSelect",
                valueOptions: filterValues ? filterValues.username : [],
                filterOperators: Utility.combinedFilters(),
                renderCell: renderCellExpand,
            },
            {
                field: "first_name",
                headerName: "NAME",
                headerAlign: "center",
                align: "center",
                minWidth: 130,
                type: "singleSelect",
                valueOptions: filterValues ? filterValues.first_name : [],
                filterOperators: Utility.combinedFilters(),
                flex: 1,
                renderCell: renderCellExpand,
            },
            {
                field: "employeename",
                headerName: "EMP NAME",
                headerAlign: "center",
                align: "center",
                minWidth: 130,
                type: "singleSelect",
                valueOptions: filterValues ? filterValues.employeename : [],
                filterOperators: Utility.combinedFilters(),
                flex: 1,
                renderCell: renderCellExpand,
            },
            {
                field: "phoneno",
                headerAlign: "center",
                align: "center",
                headerName: "PHONE",
                width: 100,
                valueFormatter: (params) => params.value,
                renderCell: renderCellExpand,
            },
            {
                field: "brokers",
                headerName: "BROKER",
                headerAlign: "center",
                align: "center",
                minWidth: 100,
                flex: 1,
                valueGetter: (params) => {
                    let brokerCompanyName = "";
                    if (params.row.brokers !== null) {
                        params.row.brokers.forEach(iBroker => {
                            brokerCompanyName += iBroker.companyname + ", ";
                        });
                    }
                    brokerCompanyName = brokerCompanyName.slice(0, -2);
                    return brokerCompanyName;
                },
                renderCell: renderCellExpand,
            },
            {
                field: "location",
                headerAlign: "center",
                align: "center",
                headerName: "LOCATION",
                width: 100,
                type: "singleSelect",
                valueOptions: filterValues ? filterValues.location : [],
                filterOperators: Utility.combinedFilters(),
            },
            {
                field: "country",
                headerName: "LOCATION COUNTRY",
                headerAlign: "center",
                align: "center",
                minWidth: 60,
                flex: 1,
                type: "singleSelect",
                valueOptions: filterValues ? filterValues.locationcountry : [],
                filterOperators: Utility.combinedFilters(),
            },
            {
                field: "customercountry",
                headerName: "COUNTRY",
                headerAlign: "center",
                align: "center",
                minWidth: 60,
                flex: 1,
                type: "singleSelect",
                valueOptions: filterValues ? filterValues.customercountry : [],
                filterOperators: Utility.combinedFilters(),
            },
            {
                field: "customerstate",
                headerName: "STATE",
                headerAlign: "center",
                align: "center",
                minWidth: 60,
                flex: 1,
                type: "singleSelect",
                valueOptions: filterValues ? filterValues.customerstate : [],
                filterOperators: Utility.combinedFilters(),
            },
            {
                field: "customercity",
                headerName: "CITY",
                headerAlign: "center",
                align: "center",
                minWidth: 60,
                flex: 1,
                type: "singleSelect",
                valueOptions: filterValues ? filterValues.customercity : [],
                filterOperators: Utility.combinedFilters(),
            },
            {
                field: "marketsellstonecount",
                headerName: "N MKT SELL COUNT",
                align: "center",
                headerAlign: "center",
                type: "number",
                valueFormatter: (params) => params.value,
                minWidth: 60,
                flex: 1,
                cellClassName: 'greenCell',
                renderHeader: () => (
                    <Tooltip title="Count of Natural Stones from Wolza" placement="bottom">
                        <span>N MKT SELL COUNT</span>
                    </Tooltip>
                ),
                renderCell: (params) => {

                    const isClickable = params.value !== 0 && params.value !== null;
                    return (<Button
                        sx={{
                            textDecorationLine: isClickable ? "underline" : "none",
                            color: "black",
                            textTransform: "none",
                            cursor: isClickable ? "pointer" : "default",
                        }}
                        onClick={isClickable ? () => handleWolzaDetail(params, NATURAL) : undefined}

                    >
                        {isClickable ? params.value : ""}
                    </Button>)
                }
            },
            {
                field: "sumofestimatedfob",
                headerName: "N SUM OF FOB",
                headerAlign: "center",
                align: "center",
                minWidth: 60,
                type: "number",
                cellClassName: 'greenCell',
                renderHeader: () => (
                    <Tooltip title="Sum of Estimated FOB Value for Natural Stones from Wolza" placement="bottom">
                        <span>N SUM OF FOB</span>
                    </Tooltip>
                ),
                valueFormatter: (params) => params.value,
                flex: 1,
                renderCell: renderCellExpand,
            },
            {
                field: "nullcertificatecount",
                headerName: "N UNPROCESSED CERTS",
                headerAlign: "center",
                align: "center",
                minWidth: 90,
                flex: 1,
                renderCell: renderCellExpand,
                renderHeader: () => (
                    <Tooltip title="Count of Unprocessed Certificates for Natural Stones from Wolza" placement="bottom">
                        <span>N UNPROCESSED CERTS</span>
                    </Tooltip>
                ),
                valueGetter: (params) => {
                    if (params.row.nullcertificatecount !== null && params.row.marketsellstonecount !== null) {
                        return params.row.nullcertificatecount + " / " + params.row.marketsellstonecount;
                    } else {
                        return "";
                    }
                },
                cellClassName: (params) => params.row.nullcertificatecount !== null && params.row.marketsellstonecount !== null &&
                    params.row.nullcertificatecount <= params.row.marketsellstonecount ? 'greenCell' : "",
            },
            {
                field: "actualsellstonecount",
                headerName: "N ACTUAL SELL COUNT",
                align: "center",
                headerAlign: "center",
                minWidth: 70,
                type: "number",
                valueFormatter: (params) => params.value,
                flex: 1,
                cellClassName: 'greenCell',
                renderHeader: () => (
                    <Tooltip title="Sell Count of Natural Stones from Our System" placement="bottom">
                        <span>N ACTUAL SELL COUNT</span>
                    </Tooltip>
                ),
                renderCell: (params) => {
                    const isClickable = params.value !== 0 && params.value !== null;

                    return (
                        <Button
                            sx={{
                                textDecorationLine: isClickable ? "underline" : "none",
                                color: "black",
                                textTransform: "none",
                                cursor: isClickable ? "pointer" : "default",
                            }}
                            onClick={isClickable ? () => handleActualInvoiceDetail(params) : undefined}
                            disabled={!isClickable}
                        >
                            {isClickable ? params.value : ""}
                        </Button>
                    );
                },
            },
            {
                field: "sumofactualsell",
                headerName: "N SUM OF ACTUAL SELL",
                headerAlign: "center",
                align: "center",
                minWidth: 90,
                flex: 1,
                type: "number",
                renderHeader: () => (
                    <Tooltip title="Total Sell Price of Natural Stones from Our System" placement="bottom">
                        <span>N SUM OF ACTUAL SELL</span>
                    </Tooltip>
                ),
                cellClassName: 'greenCell',
                valueFormatter: (params) => params.value,
                renderCell: renderCellExpand,
            },
            {
                field: "stonecount",
                headerName: "N STONE COUNT",
                headerAlign: "center",
                align: "center",
                minWidth: 120,
                flex: 1,
                type: "number",
                renderHeader: () => (
                    <Tooltip title="Total Number of Available Natural Stones for Proposal to the Customer" placement="bottom">
                        <span>N STONE COUNT</span>
                    </Tooltip>
                ),
                cellClassName: 'greenCell',
                valueFormatter: (params) => params.value,
                renderCell: renderCellExpand,
            },
            {
                field: "totalprice",
                headerName: "N TOTAL PRICE",
                headerAlign: "center",
                align: "center",
                minWidth: 90,
                flex: 1,
                type: "number",
                renderHeader: () => (
                    <Tooltip title="Total Price of Available Natural Stones for Customer Proposal" placement="bottom">
                        <span>N TOTAL PRICE</span>
                    </Tooltip>
                ),
                cellClassName: 'greenCell',
                valueFormatter: (params) => params.value,
                renderCell: renderCellExpand,
            },
            {
                field: "link",
                headerName: "N LINK",
                headerAlign: "center",
                align: "center",
                export: false,
                width: 100,
                renderHeader: () => (
                    <Tooltip title="Link for Available Natural Stones to Propose to the Customer" placement="bottom">
                        <span>N LINK</span>
                    </Tooltip>
                ),
                cellClassName: 'greenCell',
                renderCell: (params) => {
                    const rowData = params.row;
                    const showLink = (rowData.stonecount && rowData.stonecount > 0);

                    return (
                        <Box display="flex" justifyContent="center" alignItems="center">
                            {showLink && (
                                <>
                                    <Tooltip title="Open Link">
                                        <IconButton
                                            onClick={async (event) => {

                                                try {
                                                    const link = rowData.naturallink === "" ? await generateLink(rowData, NATURAL) : rowData.naturallink;
                                                    openLinkInNewTab(link);
                                                } catch (error) {
                                                    setShowSnackbar(true);
                                                    setSnackBarMessage("Failed to generate link");
                                                    setSnackBarVariant("error");
                                                    setSnackBarTitle("Error");
                                                }

                                            }}
                                        >
                                            <OpenInNewIcon />
                                        </IconButton>
                                    </Tooltip>

                                    <Tooltip title="Copy Link">
                                        <IconButton
                                            onClick={async (event) => {
                                                try {
                                                    const link = rowData.naturallink === "" ? await generateLink(rowData, NATURAL) : rowData.naturallink;
                                                    navigator.clipboard.writeText(link)
                                                        .then(() => {
                                                            setShowSnackbar(true);
                                                            setSnackBarMessage("Link Copied");
                                                            setSnackBarVariant("success");
                                                            setSnackBarTitle("Success");
                                                        })
                                                        .catch(err => {
                                                            console.error("Failed to copy link: ", err);
                                                        });
                                                } catch (error) {
                                                    setShowSnackbar(true);
                                                    setSnackBarMessage("Failed to copy link");
                                                    setSnackBarVariant("error");
                                                    setSnackBarTitle("Error");
                                                }
                                            }}
                                        >
                                            <FileCopyRoundedIcon />
                                        </IconButton>
                                    </Tooltip>
                                </>
                            )}
                        </Box>
                    );
                },
            },
            {
                field: "lg_marketsellstonecount",
                headerName: "LG MKT SELL COUNT",
                align: "center",
                headerAlign: "center",
                type: "number",
                valueFormatter: (params) => params.value,
                minWidth: 60,
                flex: 1,
                cellClassName: 'brownCell',
                renderHeader: () => (
                    <Tooltip title="Count of Lab Grown Stones from Wolza" placement="bottom">
                        <span>LG MKT SELL COUNT</span>
                    </Tooltip>
                ),
                renderCell: (params) => {
                    const isClickable = params.value !== 0 && params.value !== null;

                    return (<Button
                        sx={{
                            textDecorationLine: isClickable ? "underline" : "none",
                            color: "black",
                            textTransform: "none",
                            cursor: isClickable ? "pointer" : "default",
                        }}
                        onClick={isClickable ? () => handleWolzaDetail(params, LAB_GROWN) : undefined}
                        disabled={!isClickable}
                    >
                        {isClickable ? params.value : ""}
                    </Button>)
                }
            },
            {
                field: "lg_sumofestimatedfob",
                headerName: "LG SUM OF FOB",
                headerAlign: "center",
                align: "center",
                minWidth: 60,
                type: "number",
                cellClassName: 'brownCell',
                renderHeader: () => (
                    <Tooltip title="Sum of Estimated FOB Value for Lab Grown Stones from Wolza" placement="bottom">
                        <span>LG SUM OF FOB</span>
                    </Tooltip>
                ),
                valueFormatter: (params) => params.value,
                flex: 1,
                renderCell: renderCellExpand,
            },
            {
                field: "lg_nullcertificatecount",
                headerName: "LG UNPROCESSED CERTS",
                headerAlign: "center",
                align: "center",
                minWidth: 90,
                flex: 1,
                renderCell: renderCellExpand,
                renderHeader: () => (
                    <Tooltip title="Count of Unprocessed Certificates for Lab Grown Stones from Wolza" placement="bottom">
                        <span>LG UNPROCESSED CERTS</span>
                    </Tooltip>
                ),
                valueGetter: (params) => {
                    if (params.row.lg_nullcertificatecount !== null && params.row.lg_marketsellstonecount !== null) {
                        return params.row.lg_nullcertificatecount + " / " + params.row.lg_marketsellstonecount;
                    } else {
                        return "";
                    }
                },
                cellClassName: (params) => params.row.lg_nullcertificatecount !== null && params.row.lg_marketsellstonecount !== null &&
                    params.row.lg_nullcertificatecount <= params.row.lg_marketsellstonecount ? 'brownCell' : "",
            },
            {
                field: "lg_actualsellstonecount",
                headerName: "LG ACTUAL SELL COUNT",
                align: "center",
                headerAlign: "center",
                minWidth: 70,
                type: "number",
                cellClassName: 'brownCell',
                valueFormatter: (params) => params.value,
                renderHeader: () => (
                    <Tooltip title="Sell Count of Lab Grown Stones from Our System" placement="bottom">
                        <span>LG ACTUAL SELL COUNT</span>
                    </Tooltip>
                ),
                flex: 1,
                renderCell: (params) => {
                    const isClickable = params.value !== 0 && params.value !== null;

                    return (
                        <Button
                            sx={{
                                textDecorationLine: "underline",
                                color: "black",
                                textTransform: "none",
                            }}
                            onClick={isClickable ? () => handleActualInvoiceDetail(params) : undefined}
                            disabled={!isClickable}
                        >
                            {isClickable ? params.value : ""}
                        </Button>)
                }
            },
            {
                field: "lg_sumofactualsell",
                headerName: "LG SUM OF ACTUAL SELL",
                headerAlign: "center",
                align: "center",
                minWidth: 90,
                flex: 1,
                type: "number",
                cellClassName: 'brownCell',
                renderHeader: () => (
                    <Tooltip title="Total Sell Price of Lab Grown Stones from Our System" placement="bottom">
                        <span>LG SUM OF ACTUAL SELL</span>
                    </Tooltip>
                ),
                valueFormatter: (params) => params.value,
                renderCell: renderCellExpand,
            },
            {
                field: "lg_stonecount",
                headerName: "LG STONE COUNT",
                headerAlign: "center",
                align: "center",
                minWidth: 120,
                flex: 1,
                type: "number",
                cellClassName: 'brownCell',
                renderHeader: () => (
                    <Tooltip title="Total Number of Available Lab Grown Stones for Proposal to the Customer" placement="bottom">
                        <span>LG STONE COUNT</span>
                    </Tooltip>
                ),
                valueFormatter: (params) => params.value,
                renderCell: renderCellExpand,
            },
            {
                field: "lg_totalprice",
                headerName: "LG TOTAL PRICE",
                headerAlign: "center",
                align: "center",
                minWidth: 90,
                flex: 1,
                type: "number",
                cellClassName: 'brownCell',
                renderHeader: () => (
                    <Tooltip title="Total Price of Available Lab Grown Stones for Customer Proposal" placement="bottom">
                        <span>LG TOTAL PRICE</span>
                    </Tooltip>
                ),
                valueFormatter: (params) => params.value,
                renderCell: renderCellExpand,
            },
            {
                field: "lg_link",
                headerName: "LG LINK",
                headerAlign: "center",
                align: "center",
                export: false,
                Width: 90,
                cellClassName: 'brownCell',
                renderHeader: () => (
                    <Tooltip title="Link for Available Lab Grown Stones to Propose to the Customer" placement="bottom">
                        <span>LG LINK</span>
                    </Tooltip>
                ),
                renderCell: (params) => {
                    const rowData = params.row;
                    const showLink = (rowData.lg_stonecount && rowData.lg_stonecount > 0);

                    return (
                        <Box display="flex" justifyContent="center" alignItems="center">
                            {showLink && (
                                <>
                                    <Tooltip title="Open Link">
                                        <IconButton
                                            onClick={async (event) => {

                                                try {
                                                    const link = rowData.labgrownlink === "" ? await generateLink(rowData, LAB_GROWN) : rowData.labgrownlink;
                                                    openLinkInNewTab(link);
                                                } catch (error) {
                                                    setShowSnackbar(true);
                                                    setSnackBarMessage("Failed to generate link");
                                                    setSnackBarVariant("error");
                                                    setSnackBarTitle("Error");
                                                }

                                            }}
                                        >
                                            <OpenInNewIcon />
                                        </IconButton>
                                    </Tooltip>

                                    <Tooltip title="Copy Link">
                                        <IconButton
                                            onClick={async (event) => {
                                                try {
                                                    const link = rowData.labgrownlink === "" ? await generateLink(rowData, LAB_GROWN) : rowData.labgrownlink;
                                                    navigator.clipboard.writeText(link)
                                                        .then(() => {
                                                            setShowSnackbar(true);
                                                            setSnackBarMessage("Link Copied");
                                                            setSnackBarVariant("success");
                                                            setSnackBarTitle("Success");
                                                        })
                                                        .catch(err => {
                                                            console.error("Failed to copy link: ", err);
                                                        });
                                                } catch (error) {
                                                    setShowSnackbar(true);
                                                    setSnackBarMessage("Failed to copy link");
                                                    setSnackBarVariant("error");
                                                    setSnackBarTitle("Error");
                                                }
                                            }}
                                        >
                                            <FileCopyRoundedIcon />
                                        </IconButton>
                                    </Tooltip>
                                </>
                            )}</Box>
                    );
                },
            },
        ], [filterValues]);

    const CustomToolbar = () => {
        return (
            <GridToolbarContainer
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    "&.MuiDataGrid-toolbarContainer": {
                        padding: "0px 4px !important",
                    },
                }}
            >
                {/* LEFT SIDE: Columns, Filter, Checkbox + Label */}
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1.5,
                        flexWrap: "wrap",
                    }}
                >
                    <Tooltip title={"Enter multiple Customer Ids"}>
                        <IconButton
                            color="inherit"
                            onClick={() => setShowMultiCustomerSelectionModal(true)}
                            disabled={listData.length === 0}
                            sx={{ color: "#454545", borderColor: "#454545" }}
                        >
                            <QueueIcon />
                        </IconButton>
                    </Tooltip>

                    <GridToolbarColumnsButton />
                    <GridToolbarFilterButton />
                    <GridToolbarExport />
                    {/* Checkbox + Label */}
                    <FormGroup row sx={{ alignItems: "center" }}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    onChange={() => {
                                        setListData([]);
                                        setUnassignedCustomerCheck((prevState) => !prevState);
                                    }}
                                    sx={{ p: 0.25 }}
                                />
                            }
                            label={
                                <Typography sx={{ fontSize: 13, fontWeight: 600 }}>
                                    Unassigned Customers
                                </Typography>
                            }
                            sx={{
                                marginRight: 1,
                                marginTop: "6px"
                            }}
                        />
                    </FormGroup>
                </Box>

                {/* RIGHT SIDE: Reload, Reassign, QuickFilter */}
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1.5,
                        flexWrap: "wrap",
                    }}
                >
                    {listLoader ? (
                        <CircularProgress size="1rem" />
                    ) : (
                        <Tooltip title="Reload List">
                            <RefreshOutlinedIcon
                                onClick={() => {
                                    if (employeeData.employee.length > 0 && employeeData.employee[0] !== null) {
                                        handleSearch();
                                    }
                                }}
                                color="primary"
                                fontSize="medium"
                                sx={{ cursor: "pointer" }}
                            />
                        </Tooltip>
                    )}

                    <Tooltip title={"Reassign Customers"}>
                        <Button
                            variant="outlined"
                            size="small"
                            component="label"
                            startIcon={<TransferWithinAStationIcon />}
                            disabled={selectionModel.length < 1 || listLoader}
                            onClick={() => {
                                setShowSelectUserModal(true);
                                filterEmployeeData();
                            }}
                            sx={{
                                height: "32px",
                                "& .Mui-disabled": {
                                    color: "rgba(0,0,0,0.26) !important",
                                },
                            }}
                        >
                            REASSIGN
                        </Button>
                    </Tooltip>

                    <GridToolbarQuickFilter debounceMs={500} />
                </Box>

                {/* Modal */}
                {showSelectUserModal && (
                    <SelectUserModal
                        show={showSelectUserModal}
                        setShow={setShowSelectUserModal}
                        handleSave={saveReassign}
                        loading={loadingButton}
                        filteredEmployeeData={filteredEmployeeData}
                        setFilteredEmployeeData={setFilteredEmployeeData}
                    />
                )}
            </GridToolbarContainer>
        );
    };

    const rows = listData;

    return (
        !allowed ? <NoPermission /> :
            <div>
                {showWolzaDetailModal ? (
                    <Modal
                        enforceFocus={false}
                        show={showWolzaDetailModal}
                        onHide={() => setShowWolzaDetailModal(false)}
                        dialogClassName="max-modalSize"
                        style={{ zIndex: 1050 }}
                    >
                        <Modal.Header closeButton>
                            <Modal.Title>
                                <img
                                    src={logo}
                                    height="40pt"
                                    width="40pt"
                                    alt={Constants.COMPANY_SITE}
                                />
                                &nbsp;&nbsp;
                                Wolza Details
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <MarketSellWolzaModal
                                handleClose={() => setShowWolzaDetailModal(false)}
                                stone={null}
                                loadedCustomers={customerData}
                                fromDate={fromDate}
                                toDate={toDate}
                                mappingkey={"hasMapping"}
                                stoneType={stoneType}
                            />
                        </Modal.Body>
                    </Modal>
                ) : null}
                {showInvoiceModal ? (
                    <SystemSalesModal
                        show={showInvoiceModal}
                        handleClose={() => setShowInvoiceModal(false)}
                        loadedCustomers={customerData}
                        defaultfromdate={fromDate}
                        defaulttodate={toDate}
                        defaultStatus={defaultStatus}
                        onHide={() => setShowInvoiceModal(false)}
                    />

                ) : null}
                {showSnackbar ? (
                    <CommonSnackbar
                        show={showSnackbar}
                        message={snackBarMessage}
                        variant={snackBarVariant}
                        autoHide={false}
                        title={snackBarTitle}
                        handleClose={() => { setShowSnackbar(false); }}
                    />)
                    : null}
                {showUserDetailModal ? (
                    <UserDetailModal
                        show={true}
                        handleClose={() => setShowUserDetailModal(false)}
                        handleSelect={(selectedOption) => {
                            const selectedCustomers = employeeData.employeeOptions.filter(opt =>
                                selectedOption.includes(opt.value)
                            );
                            setEmployeeData({
                                ...employeeData,
                                employee: selectedCustomers,
                            })
                            setShowUserDetailModal(false)
                        }}
                        userids={userIds}
                        selectedIds={employeeData.employee.length !== 0 ? employeeData.employee.map(iEmployee => iEmployee.value) : []}
                        usertype={"E"}
                        loading={showUserDetailModal}
                        isMulti={true}
                    />
                ) : null}
                {showMultiCustomerSelectionModal ?
                    (<div>
                        <Modal show={showMultiCustomerSelectionModal} onHide={handleClose} enforceFocus={false}>
                            <Modal.Header closeButton>
                                <Modal.Title>
                                    <img
                                        src={logo}
                                        height="40pt"
                                        width="40pt"
                                        alt={Constants.COMPANY_SITE}
                                    />
                                    &nbsp;&nbsp;Multiple Customer Selection
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <Container maxWidth="xxl">
                                    <Box
                                        sx={{
                                            width: "100%",
                                            position: "relative",
                                            "& .MuiTablePagination-selectLabel": {
                                                marginTop: "15px",
                                            },
                                            "& .MuiTablePagination-displayedRows": {
                                                marginTop: "15px",
                                            },
                                            "& .css-1jbbcbn-MuiDataGrid-columnHeaderTitle": {
                                                fontWeight: Constants.defaultFontWeight,
                                            },
                                            "& .css-1knaqv7-MuiButtonBase-root-MuiButton-root": {
                                                color: "#1976d2",
                                                padding: "4px 5px",
                                                borderRadius: "4px",
                                            },
                                            "& .css-cc8tf1": {
                                                fontWeight: Constants.defaultFontWeight,
                                            },
                                            "& .css-znmrd6-MuiButtonBase-root-MuiButton-root": {
                                                color: "#1976d2",
                                                padding: "5px 5px",
                                                borderRadius: "4px",
                                            },
                                            height: "20vh",
                                        }}
                                    >
                                        <TextField
                                            margin="normal"
                                            fullWidth
                                            multiline
                                            rows={4}
                                            placeholder={"Enter multiple customer ids"}
                                            value={data}
                                            onChange={(e) =>
                                                setData(
                                                    Utility.ConvertNewLineToComma(e.target.value)
                                                )
                                            }
                                        />
                                    </Box>

                                </Container>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button sx={{ mr: 1 }} variant="contained" color="info" onClick={handleSubmit}>
                                    Submit
                                </Button>
                                <Button variant="contained" color="error" onClick={handleClose}>
                                    Close
                                </Button>
                            </Modal.Footer>
                        </Modal>
                    </div>) : null
                }
                <Box
                    sx={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "15px",
                        alignItems: "center",
                        my: 2,
                        ml: 2,
                    }}
                >
                    {/* Employee Filter */}
                    <Box
                        sx={{
                            display: "flex",
                            flexWrap: "wrap",
                            gap: "15px",
                            alignItems: "center",
                            width: "80%",
                        }}
                    >
                        <Box
                            sx={{
                                display: "flex",
                                flex: "1 1 300px",
                                minWidth: "260px",
                                gap: "5px",
                                alignItems: "center",
                            }}
                        >
                            <Box sx={{ alignSelf: "center", width: "6rem" }}>
                                <Typography>Employee</Typography>
                            </Box>
                            <Box
                                sx={{
                                    flex: 1,
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "15px",
                                }}
                            >
                                <Box sx={{ flex: 1 }}>
                                    <Select
                                        menuPlacement="auto"
                                        blurInputOnSelect={false}
                                        className="basic-single"
                                        classNamePrefix="select"
                                        isClearable={true}
                                        isMulti
                                        getOptionLabel={(option) => option.label}
                                        getOptionValue={(option) => option.value}
                                        value={employeeData.employee}
                                        isSearchable={true}
                                        name="Employee"
                                        isDisabled={unassignedCustomerCheck}
                                        menuPortalTarget={document.body}
                                        styles={Constants.Styles}
                                        options={employeeData.employeeOptions}
                                        onChange={(selectedOption) => {
                                            setEmployeeData({
                                                ...employeeData,
                                                employee: selectedOption,
                                            });
                                        }}
                                    />
                                </Box>
                                <Tooltip title="View More Data">
                                    <span style={{ cursor: "pointer" }}>
                                        <OpenInNewIcon
                                            style={{ fontSize: "20px", marginBottom: "3px" }}
                                            onClick={() => {
                                                setShowUserDetailModal(true);
                                            }}
                                            color="action"
                                        />
                                    </span>
                                </Tooltip>
                            </Box>
                        </Box>

                        {/* From Date */}
                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                gap: "10px",
                                flex: "1 1 200px",
                                minWidth: "180px",
                                "& .MuiOutlinedInput-root": {
                                    height: "2.45rem",
                                },
                            }}
                        >
                            <Typography m={0}>From</Typography>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    className="picker"
                                    renderInput={(props) => (
                                        <TextField
                                            fullWidth
                                            {...props}
                                            inputProps={{ ...props.inputProps, readOnly: true }}
                                        />
                                    )}
                                    value={fromDate}
                                    inputFormat="DD/MM/YYYY"
                                    onChange={(newValue) => {
                                        const now = dayjs();
                                        const fromDate = dayjs(newValue)
                                            .hour(now.hour())
                                            .minute(now.minute())
                                            .second(now.second())
                                            .millisecond(now.millisecond())
                                            .toDate();
                                        setFromDate(fromDate);
                                    }}
                                />
                            </LocalizationProvider>
                        </Box>

                        {/* To Date */}
                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                gap: "10px",
                                flex: "1 1 200px",
                                minWidth: "180px",
                                "& .MuiOutlinedInput-root": {
                                    height: "2.45rem",
                                },
                            }}
                        >
                            <Typography m={0}>To</Typography>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    className="picker"
                                    renderInput={(props) => (
                                        <TextField
                                            fullWidth
                                            {...props}
                                            inputProps={{ ...props.inputProps, readOnly: true }}
                                        />
                                    )}
                                    value={toDate}
                                    inputFormat="DD/MM/YYYY"
                                    onChange={(newValue) => {
                                        const now = dayjs();
                                        const toDate = dayjs(newValue)
                                            .hour(now.hour())
                                            .minute(now.minute())
                                            .second(now.second())
                                            .millisecond(now.millisecond())
                                            .toDate();
                                        setToDate(toDate);
                                    }}
                                />
                            </LocalizationProvider>
                        </Box>

                        {/* Clear Button */}
                        <Box mt="0.4rem">
                            <Tooltip title="Clear Date">
                                <ClearIcon
                                    onClick={() => {
                                        setFromDate(null);
                                        setToDate(null);
                                    }}
                                    color="primary"
                                    fontSize="medium"
                                    sx={{ cursor: "pointer", mr: 1 }}
                                />
                            </Tooltip>
                        </Box>

                        {/* Search Button */}
                        <Box
                            sx={{
                                "& .Mui-disabled": {
                                    backgroundColor: "rgba(0, 0, 0, 0.12) !important",
                                    color: "rgba(0, 0, 0, 0.26) !important",
                                },
                                flex: "1 1 auto",
                                minWidth: "160px",
                            }}
                        >
                            <Button
                                variant="contained"
                                size="large"
                                onClick={() => {
                                    if (employeeData.employee.length > 0 && employeeData.employee[0] !== null) {
                                        handleSearch();
                                    }
                                }}
                                startIcon={<SearchOutlinedIcon size="large" />}
                                sx={{ alignSelf: "center", ml: 2 }}
                                disabled={employeeData.employee.length === 0 || employeeData.employee[0] === null || listLoader}
                            >
                                Search
                            </Button>
                        </Box>
                    </Box>
                </Box>
                <div>
                    <Box
                        sx={{
                            px: 1,
                            width: "100%",
                            position: "relative",
                            backgroundColor: '#fff',
                            color: '#000',
                            "& .MuiTablePagination-selectLabel": {
                                marginTop: "15px",
                            },
                            "& .MuiTablePagination-displayedRows": {
                                marginTop: "15px",
                            },
                            "& .css-1jbbcbn-MuiDataGrid-columnHeaderTitle": {
                                fontWeight: Constants.defaultFontWeight,
                            },
                            "& .css-1knaqv7-MuiButtonBase-root-MuiButton-root": {
                                color: "#1976d2",
                                padding: "4px 5px",
                                borderRadius: "4px",
                            },
                            "& .css-znmrd6-MuiButtonBase-root-MuiButton-root": {
                                color: "#1976d2",
                                padding: "5px 5px",
                                borderRadius: "4px",
                            },
                            "& .css-cc8tf1": {
                                fontWeight: Constants.defaultFontWeight,
                            },
                            "& .lavenderCell": {
                                color: "#080808 !important",
                                backgroundColor: "#D8BFD8 !important",
                            },
                            "& .greenCell": {
                                color: "#080808",
                                backgroundColor: "#C6DCBA",
                            },
                            "& .brownCell": {
                                color: "#080808",
                                backgroundColor: "#ebbdaa",
                            },
                            height: "75vh",
                        }}
                    >
                        <DataGridPro
                            sx={{
                                '& .MuiDataGrid-columnHeader': {
                                    color: '#fff',
                                    backgroundColor: 'grey',
                                },
                                "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
                                    py: "6px",
                                },
                                "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
                                    py: "12px",
                                },
                                "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
                                    py: "18px",
                                },

                                fontSize: Constants.defaultTableFontSize, fontWeight: Constants.defaultFontWeight,
                            }}
                            density="compact"
                            disableRowSelectionOnClick={true}
                            slots={{
                                toolbar: CustomToolbar,
                            }}
                            rows={rows}
                            columns={columns}
                            getRowId={(row) => row.id}
                            checkboxSelection={true}
                            onRowSelectionModelChange={(newSelectionModel) => {
                                setSelectionModel(newSelectionModel);
                            }}
                            loading={listLoader}
                            rowSelectionModel={selectionModel}
                            initialState={{
                                columns: {
                                    columnVisibilityModel: {
                                        // Hide columns id, the other columns will remain visible
                                        locationid: false,
                                    },
                                },
                                pagination: {
                                    paginationModel: Constants.pageSize,
                                },
                            }}
                            pageSizeOptions={Constants.pageSizeOptions}
                            pagination
                            slotProps={{
                                toolbar: {
                                    showQuickFilter: true,
                                    quickFilterProps: {
                                        debounceMs: 500,
                                    },
                                },
                            }}
                        />
                    </Box>
                </div>
            </div>
    );
};
export default ReassignCustomer;
